import { render } from "./ListNotification.vue?vue&type=template&id=1ed242e6"
import script from "./ListNotification.vue?vue&type=script&lang=js"
export * from "./ListNotification.vue?vue&type=script&lang=js"

import "./ListNotification.vue?vue&type=style&index=0&id=1ed242e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__